import { render, staticRenderFns } from "./TabDadosUsuario.vue?vue&type=template&id=0ef481cf&scoped=true&"
import script from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
export * from "./TabDadosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabDadosUsuario.vue?vue&type=style&index=0&id=0ef481cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef481cf",
  null
  
)

export default component.exports